@if (showAddToGpay) {
<div [ngStyle]="buttonStyle" class="is-center p-5" (click)="onClickAddToGpay()" [innerHTML]="modifiedSvg | safeHtml">
</div>
}